export default "__VITE_ASSET__e34d19a5__"